<template>
  <DynamicScroller
    :items="items"
    :min-item-size="0"
    class="scroller"
    key-field="id"
  >
    <template v-slot="{ item, index, active }">
      <!-- <DynamicScrollerItem
        :item="item"
        :active="active"
        :size-dependencies="[
          item.name,
        ]"
        :data-index="index"
      >
        <div class="text">{{ item.name }}</div>
      </DynamicScrollerItem> -->
    </template>
  </DynamicScroller>
</template>

<script>
export default {
  data : function () {
      return {
          items : []
      };
  },
  created : function () {
      for (let i = 0; i < 1000; i++) {
          this.items.push({
              name : 'Test ' + i,
              id : i
          });
      }
  }
}
</script>

<style scoped>
.scroller {
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/TablaTest.vue